import { DateTimeHelper } from "src/app/core/helper/datetime.helper";

export class Prize {
    name: string;
    description: string;
    image1Path: string;
    drawDate: string | null;

    endFmt: string;
    drawFmt: string;

    isEarlyBird: boolean = false;

    public constructor(init?: Partial<Prize>) {
        Object.assign(this, init);

        if (this.drawDate != null) {
            this.drawFmt  = DateTimeHelper.formatDate(`${this.drawDate}Z`);
        }
    }
}